import { render, staticRenderFns } from "./PASSSET.vue?vue&type=template&id=4474dc42&"
import script from "./PASSSET.vue?vue&type=script&lang=js&"
export * from "./PASSSET.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports